import React, { useState } from "react";

import { PageLayout, PageHeader } from "../components/layout";
import { PageFilterBar, ScopeSelect, SearchInput } from "../components/ui";
import { AlertListProvider, useAlertList } from "./useAlertList";
import AlertList from "./components/AlertList";
import RCAlertCard from "./components/RCAlertCard";
import "./rc-buy-alerts-page.scss";
import { HOME_PATH } from "../core/config/dashboard.js";

const actions = [{ label: "+ New Alert", to: "/alerts/create", variant: "primary", size: "lg", className: "rc-ui-btn--hero", "data-btn": "alert-new" }];

// Single-tab section bar, mirroring RCListingsPage's PageHeader tabs — the
// client asked for a "BUY ALERTS" tab on the same row as "+ New Alert",
// matching the shared page-chrome convention.
const tabs = [{ label: "BUY ALERTS", to: "/alerts" }];

const STATUS_OPTIONS = [
  { key: "active", label: "Active" },
  { key: "inactive", label: "Inactive" },
];

const RCBuyAlertsInner = () => {
  const [searchVal, setSearchVal] = useState("");

  const {
    count,
    listParams,
    onSearchQueryChange,
    showActive,
    setShowActive,
    showInactive,
    setShowInactive,
  } = useAlertList();

  const handleSearch = (e) => {
    setSearchVal(e.target.value);
    onSearchQueryChange(e.target.value);
  };

  return (
    <PageLayout className="rc-buy-alerts-page">
      <PageHeader
        title="Buy Alert"
        description="Get notified when a matching watch appears at the price you want"
        backTo={HOME_PATH}
        tabs={tabs}
        actions={actions}
        activePath="/alerts"
      />

      {/* The shared row (PageFilterBar, M54D) — this page's geometry is now the
          base every other filter row is built on. */}
      <PageFilterBar className="rc-bap__filterbar" label="Filter alerts"
        search={(
          <SearchInput
            size="lg"
            value={searchVal}
            onChange={handleSearch}
            placeholder="Search alerts ..."
          />
        )}
      >
        {/* Was two Toggle pills. Same state, same `status` payload — now the
            shared ScopeSelect dropdown so this row reads identically to
            Manage Listings' "All listings". Single mode: `alert.status` is
            one boolean on the backend, so the options are exclusive (the
            hook already enforced that between the two pills). */}
        <ScopeSelect
          label="Alert status"
          placeholder="All alerts"
          multiple={false}
          options={STATUS_OPTIONS}
          value={showActive ? "active" : showInactive ? "inactive" : null}
          onChange={(next) => {
            setShowActive(next === "active");
            setShowInactive(next === "inactive");
          }}
        />
      </PageFilterBar>

      <div className="rc-bap__count-row">
        <span className="rc-bap__count">
          {count != null ? count : "—"} {count === 1 ? "alert" : "alerts"}
        </span>
      </div>

      <div className="rc-bap__grid">
        <AlertList itemComponent={RCAlertCard} limit={24} {...listParams} />
      </div>
    </PageLayout>
  );
};

const RCBuyAlertsPage = () => (
  <AlertListProvider key="rc-buy-alerts">
    <RCBuyAlertsInner />
  </AlertListProvider>
);

export default RCBuyAlertsPage;
